<template>
  <oops v-if="showOops" :row-type="rowType"/>
  <item-page v-else
    :show-progress="showProgress"
    :item-reason="itemReason"
    :row-type="rowType"
    :item="item"
    :content-heading="contentHeading"
    :item-obj="itemReason"
    :item-name="itemName"
    :row-types="rowTypes"
    :auth="auth"
  />
</template>
<script>
import Itempage from '@/components/Itempage'
import oops from '@/components/Oops'
import { CompanyPage, Controls } from '@/gql'
import { mergeControls } from '@/js/apollo'
import { SearchUtils } from '@/js'
export default {
  components: {
    'item-page': Itempage,
    oops
  },
  props: {
    auth: Object
  },
  data: () => ({
    rowTypes: ['film', 'person', 'brand', 'product']
  }),
  computed: {
    showOops() {
      return !this.itemMake && !this.$apollo.loading;
    },
    contentHeading () {
      return 'Company details'
    },
    rowType () {
      return 'company'
    },
    itemName () {
      return 'Company'
    },
    company () {
      return this.itemReason
    },
    passedItem () {
      return this.params.item
    },
    showProgress () {
      return this.itemMake && !this.itemMake.big
    },
    item () {
      return this.itemMake && this.itemMake.item
    },
    itemMake () {
      // so use anything that we already have to start building thepage while the query is still in progress
      let item = SearchUtils.makeSearcherFromCompany(this.CompanyPage)
      if (item) {
        return {
          item,
          big: true
        }
      }
      if (!this.passedItem) {
        return null
      }
      // we got one, so make it look like it was the result of a search
      item = this.passedItem
      if (this.rowType !== item.itemType) {
        console.log(`expected ${this.rowType} but got item ${item.itemType}`)
      }
      return {
        item
      }
    },
    refresh () {
      return this.Controls && this.Controls.refresh
    },
    fetchPolicy () {
      return this.refresh ? 'no-cache' : 'cache-first'
    },
    params () {
      return this.$route.params
    },
    id () {
      return this.params.id
    },
    itemReason () {
      return this.item && this.item.itemReason
    }
  },
  apollo: {
    Controls: {
      query: Controls
    },
    CompanyPage: {
      query: CompanyPage,
      fetchPolicy () {
        return this.fetchPolicy
      },
      variables () {
        return {
          id: this.id
        }
      },
      result () {
        if (this.refresh) {
          mergeControls({
            refresh: false
          })
        }
      }
    }
  }
}
</script>
